import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { StyledOrderBlock, StyledBottomBlock } from "./style";
import rightArrow from "../../assets/images/right-arrow.png";
import { useDispatch, useSelector } from "react-redux";
import { getOrderDetailsByOrderId, resendMail, uploadVisaDocument } from "../../features/order/orderSlice";
import moment from "moment";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as yup from "yup";
import AddComment from "./AddComment/AddComment";
import MyModal from "../Modal/Modal";
import EmailContent from "./EmailContent/EmailContent";
import { convertToTitleCase, capitalizeFirstLetter, getPhoneCode } from "../../utils/utility";

import CustomDeclarationDetails from "./CustomDeclarationDetails";
import Declarations from "./Declarations";
import DefenceContent from "./DefenceContent/DefenceContent";
import TransactionModal from "./TransactionModal/TransactionModal";
import { mainDocumentArr } from "../../utils/constants";


const ViewOrders = () => {
    const dispatch = useDispatch();
    const { orderId } = useParams();
    const [show, setShow] = useState(false);
    const [showDefencePack, setShowDefencePack] = useState(false);
    const [showDefence, setShowDefence] = useState(false);
    const [showTransaction, setShowTransaction] = useState(false);

    const OrderDetails = useSelector((state) => state?.order?.orderDetails);

    const isLoading = useSelector((state) => state?.order?.loading);
    const [selectedData, setSelectedData] = useState({
        showData: false,
        dataId: 0,
    });
    const [emailId, setEmailId] = useState(OrderDetails?.contact_email_address);
    const [orderid, setEmailIdOrderid] = useState(OrderDetails?.order_id);
    const [mailServiceProvider, setMailServiceProvider] = useState('AWS');

    const uploadSchema = yup.object({
        email: yup.string().required("Please enter your email"),
        fileUpload: yup.mixed().required("File is required"),
    });

    useEffect(() => {
        if (orderId) {
            dispatch(getOrderDetailsByOrderId(orderId));
        }

        document.title = "Ind-evoa";
    }, [dispatch, orderId]);

    useEffect(() => {
        if (
            (OrderDetails &&
                typeof OrderDetails !== "undefined" &&
                OrderDetails?.contact_email_address &&
                typeof emailId === "undefined") ||
            orderId !== orderid
        ) {
            setEmailId(OrderDetails?.contact_email_address);
        }
    }, [OrderDetails, orderid]);

    let defaultInitialValues = {
        orderId: OrderDetails?.order_id,
        email: "",
        fileUpload: "",
    };

    if (orderId !== null && orderId !== undefined && OrderDetails !== null) {
        defaultInitialValues = {
            orderId: OrderDetails?.order_id,
            email: OrderDetails?.contact_email_address,
            fileUpload: "",
        };
    }

    let [initialValues, setInitialValues] = useState(defaultInitialValues);

    const { values, errors, handleBlur, handleSubmit, handleChange, setFieldValue, resetForm } = useFormik({
        initialValues: orderId !== null ? defaultInitialValues : initialValues,
        enableReinitialize: true,
        validationSchema: uploadSchema,
        onSubmit: (values) => {
            const data = new FormData();
            data.append("orderId", values.orderId);
            data.append("email", values.email);
            data.append("uploadVisaDoc", values.fileUpload);
            data.append("mailServiceProvider", mailServiceProvider);
            dispatch(uploadVisaDocument(data)).unwrap().then((res) => {
                resetForm();
                if (res.status === 1) {
                    toast.success(`${res.message}`, {
                        className: "toast-message",
                    });
                    dispatch(getOrderDetailsByOrderId(orderId));
                }
            });
        },
    });

    const handleResendMail = (e, serviceProvider) => {
        e.preventDefault();
        setMailServiceProvider(serviceProvider);
        const data = {
            orderId: OrderDetails?.order_id,
            email: emailId,
            mailServiceProvider: serviceProvider
        };
        dispatch(resendMail(data)).unwrap().then((res) => {
            if (res.status === 1) {
                toast.success(`${res.message}`, {
                    className: "toast-message",
                });
                dispatch(getOrderDetailsByOrderId(orderId));
            }
        });
    };


    const labelMapping = {
        'Personal Bank Statement With Minimum Amount USD $2000': 'personal_bank_statement_with_minimum_amount_usd_2000',
        'Proof of Living Expenses (USD$5000)': 'proof_of_living_expenses_usd_5000_',
        'Proof of Guarantee of His/Her Parents': 'proof_of_guarantee_of_his_her_parents',
        'Proof of Turnover/Sales Financial Statements': 'proof_of_turnover_sales_financial_statements',
        'Identity Card/Family Republic of Indonesia': 'identity_card_family_republic_of_indonesia',
        'Birth Certificate/Family': 'birth_certificate_family',
    };

    const formatKey = (key) => {
        return labelMapping[key] || key.toLowerCase().replace(/\s+/g, '_');
    };

    // const customDeclarationOptions = [
    //     {
    //         key: 'philippine_currency',
    //         label: '1. Philippine Currency and/or any Philippine Monetary Instrument in excess of PhP 50,000.00; (i.e. Check, Bank, Draft , etc);'
    //     },
    //     {
    //         key: 'foreign_currency',
    //         label: '2. Foreign Currency and/or Foreign Monetary Instrument in excess of USD 10,000.00 or its equivalent;'
    //     },
    //     {
    //         key: 'gambling_paraphernalia',
    //         subKey: 'gambling_paraphernalia_info',
    //         label: '3. Gambling Paraphernalia'
    //     },
    //     {
    //         key: 'cosmetics_skincare',
    //         subKey: 'cosmetics_skincare_info',
    //         label: '4. Cosmetics, skin care products, food supplements and medicines in excess of quantities for personal use;'
    //     },
    //     {
    //         key: 'dangerous_drugs',
    //         subKey: 'dangerous_drugs_info',
    //         label: '5. Dangerous drugs such as morphine, marijuana, opium, poppies or synthetic drugs;'
    //     },
    //     {
    //         key: 'firearms_ammunitions',
    //         subKey: 'firearms_ammunitions_info',
    //         label: '6. Firearms, ammunitions and explosives;'
    //     },
    //     {
    //         key: 'alcohol_tobacco',
    //         subKey: 'alcohol_tobacco_info',
    //         label: '7. Alcohol and/or tobacco products in commercial quantities;'
    //     },
    //     {
    //         key: 'foodstuff_fruit',
    //         subKey: 'foodstuff_fruit_info',
    //         label: '8. Foodstuff(s), fruit(s), vegetable(s), live animal(s) (i.e. meat,eggs etc.), marine and aquatic products(s), plant(s) and/or the product(s) and their by-product(s);'
    //     },
    //     {
    //         key: 'mobile_phones',
    //         subKey: 'mobile_phones_info',
    //         label: '9. Mobile phones, hand-held radios and similar gadgets in excess of quantities for personal use, and radio commumication equipments;'
    //     },
    //     {
    //         key: 'cremains_human',
    //         subKey: 'cremains_human_info',
    //         label: '10.Cremains (human ashes), human organs or tissues;'
    //     },
    //     {
    //         key: 'jewelry_gold',
    //         subKey: 'jewelry_gold_info',
    //         label: '11.Jewelry, gold, precious metals or gem'
    //     },
    //     {
    //         key: 'other_goods',
    //         subKey: 'other_goods_info',
    //         label: '12. Other goods, not mentioned above;'
    //     },
    // ];

    // const declarationFields = {
    //     gambling_paraphernalia_info: [
    //         { label: 'Gambling Paraphernalia Description', field: 'gambling_paraphernalia_description' },
    //         { label: 'Gambling Paraphernalia Quantity', field: 'gambling_paraphernalia_quantity' },
    //         { label: 'Gambling Paraphernalia Amount in USD', field: 'gambling_paraphernalia_amount_in_usd' },
    //     ],
    //     cosmetics_skincare_info: [
    //         { label: 'Cosmetics Skincare Description', field: 'cosmetics_skincare_description' },
    //         { label: 'Cosmetics Skincare Quantity', field: 'cosmetics_skincare_quantity' },
    //         { label: 'Cosmetics Skincare Amount in USD', field: 'cosmetics_skincare_amount_in_usd' },
    //     ],
    //     dangerous_drugs_info: [
    //         { label: 'Dangerous Drugs Description', field: 'dangerous_drugs_description' },
    //         { label: 'Dangerous Drugs Quantity', field: 'dangerous_drugs_quantity' },
    //         { label: 'Dangerous Drugs Amount in USD', field: 'dangerous_drugs_amount_in_usd' },
    //     ],
    //     firearms_ammunitions_info: [
    //         { label: 'Firearms Ammunitions Description', field: 'firearms_ammunitions_description' },
    //         { label: 'Firearms Ammunitions Quantity', field: 'firearms_ammunitions_quantity' },
    //         { label: 'Firearms Ammunitions Amount in USD', field: 'firearms_ammunitions_amount_in_usd' },
    //     ],
    //     alcohol_tobacco_info: [
    //         { label: 'Alcohol Tobacco Description', field: 'alcohol_tobacco_description' },
    //         { label: 'Alcohol Tobacco Quantity', field: 'alcohol_tobacco_quantity' },
    //         { label: 'Alcohol Tobacco Amount in USD', field: 'alcohol_tobacco_amount_in_usd' },
    //     ],
    //     foodstuff_fruit_info: [
    //         { label: 'Foodstuff Fruit Description', field: 'foodstuff_fruit_description' },
    //         { label: 'Foodstuff Fruit Quantity', field: 'foodstuff_fruit_quantity' },
    //         { label: 'Foodstuff Fruit Amount in USD', field: 'foodstuff_fruit_amount_in_usd' },
    //     ],
    //     mobile_phones_info: [
    //         { label: 'Mobile Phones Description', field: 'mobile_phones_description' },
    //         { label: 'Mobile Phones Quantity', field: 'mobile_phones_quantity' },
    //         { label: 'Mobile Phones Amount in USD', field: 'mobile_phones_amount_in_usd' },
    //     ],
    //     cremains_human_info: [
    //         { label: 'Cremains Human Description', field: 'cremains_human_description' },
    //         { label: 'Cremains Human Quantity', field: 'cremains_human_quantity' },
    //         { label: 'Cremains Human Amount in USD', field: 'cremains_human_amount_in_usd' },
    //     ],
    //     jewelry_gold_info: [
    //         { label: 'Jewelry Gold Description', field: 'jewelry_gold_description' },
    //         { label: 'Jewelry Gold Quantity', field: 'jewelry_gold_quantity' },
    //         { label: 'Jewelry Gold Amount in USD', field: 'jewelry_gold_amount_in_usd' },
    //     ],
    //     other_goods_info: [
    //         { label: 'Other Goods Description', field: 'other_goods_description' },
    //         { label: 'Other Goods Quantity', field: 'other_goods_quantity' },
    //         { label: 'Other Goods Amount in USD', field: 'other_goods_amount_in_usd' },
    //     ]
    // }

    // const dereferenceField = () => {
    //     console.log("mainDocumentArr",mainDocumentArr["General, Family or Social"]["Tourism, Family Visit, and Transit"]["B1 - Tourist (Visa On Arrival)"]);
    //     return mainDocumentArr["General, Family or Social"]["Tourism, Family Visit, and Transit"]["B1 - Tourist (Visa On Arrival)"];
    // };

    // useEffect(()=> {
    //    const result =  dereferenceField();
    //    console.log('result: ', result['Passport Valid for At Least 6 Months']);
    // },[])

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    {OrderDetails?.mailHistory?.length !== 0 && (
                        <StyledOrderBlock>
                            <h2>Email History</h2>
                            <div className="table-block table-responsive">
                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ width: "5%" }}>#</th>
                                            <th style={{ width: "10%" }}>Order ID</th>
                                            <th style={{ width: "30%" }}>Download</th>
                                            <th style={{ width: "25%" }}>Date & Time</th>
                                            <th style={{ width: "30%" }}>Mail Provider</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {OrderDetails?.mailHistory?.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td className="font-normal">{item?.order_id}</td>
                                                    {OrderDetails?.uploadDoc?.length ? (
                                                        <td>
                                                            <a
                                                                href={
                                                                    OrderDetails?.length !== 0
                                                                        ? `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_PUBLIC_UPLOAD_PATH
                                                                        }docs/${OrderDetails?.order_id}_${item?.uploadDoc == null
                                                                            ? OrderDetails?.uploadDoc[0]?.file1
                                                                            : item?.uploadDoc.file1
                                                                        }`
                                                                        : null
                                                                }
                                                                className="blue-btn"
                                                                download
                                                                rel="noreferrer"
                                                            >
                                                                Download File{" "}
                                                            </a>
                                                        </td>
                                                    ) : (
                                                        ""
                                                    )}
                                                    <td>
                                                        {moment(item?.create_ts).utc().format(
                                                            "MM/DD/YYYY h:mm:ss"
                                                        )}
                                                    </td>
                                                    <td>{item?.uploadDoc?.mail_service_provider}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                                <form className="form-inline">
                                    <div className="form-group">
                                        <label>
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                className="form-control input-class"
                                                value={emailId}
                                                onChange={(e) => setEmailId(e.target.value)}
                                            />
                                        </label>
                                    </div>
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="blue-btn"
                                            id="download_btn"
                                            disabled={isLoading}
                                            onClick={(e) => {
                                                handleResendMail(e, "AWS");
                                            }}
                                        >
                                            Resend Mail(AWS){" "}
                                            <span>
                                                <img src={rightArrow} alt="rightArrow" />
                                            </span>
                                        </button>

                                        <button
                                            type="button"
                                            className="blue-btn"
                                            id="download_btn_sendgrid"
                                            disabled={isLoading}
                                            onClick={(e) => {
                                                handleResendMail(e, "Sendgrid");
                                            }}
                                        >
                                            Resend Mail(Sendgrid){" "}
                                            <span>
                                                <img src={rightArrow} alt="rightArrow" />
                                            </span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </StyledOrderBlock>
                    )}
                </div>
                <div className="col-md-12">
                    <StyledOrderBlock>
                        <h2>Upload Document</h2>
                        <div className="table-block table-responsive fw-mobileview">
                            <form onSubmit={handleSubmit}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "15%" }}>Order ID</td>
                                            <td style={{ width: "35%" }} className="font-normal">
                                                <input
                                                    type="text"
                                                    name="orderId"
                                                    className="form-control"
                                                    placeholder="Order ID"
                                                    disabled
                                                    value={values?.orderId}
                                                />
                                            </td>
                                            <td style={{ width: "15%" }}>Email ID</td>
                                            <td style={{ width: "35%" }}>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    className="form-control"
                                                    value={values?.email}
                                                    onChange={handleChange}
                                                    placeholder="Email"
                                                />
                                                <p>{errors.email}</p>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>PDF</td>
                                            <tr>
                                                <td>
                                                    <label className="file-upload">
                                                        <input
                                                            type="file"
                                                            className=""
                                                            id="fileUpload"
                                                            name="fileUpload"
                                                            accept=".pdf,image/*"
                                                            onChange={(e) =>
                                                                setFieldValue(
                                                                    "fileUpload",
                                                                    e.currentTarget.files[0]
                                                                )
                                                            }
                                                            onBlur={handleBlur}
                                                        />
                                                        <span>Choose File</span>
                                                    </label>
                                                    <span className="slcted-file"></span>
                                                    <p>{errors.fileUpload}</p>
                                                </td>
                                            </tr>
                                        </tr>
                                        {OrderDetails?.uploadDoc?.length ? (
                                            <td colSpan="2">
                                                <a
                                                    href={
                                                        OrderDetails?.length !== 0
                                                            ? `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_PUBLIC_UPLOAD_PATH}docs/${OrderDetails?.uploadDoc[0]?.file1}`
                                                            : null
                                                    }
                                                    className="blue-btn"
                                                    download
                                                    rel="noreferrer"
                                                >
                                                    Download File{" "}
                                                </a>
                                            </td>
                                        ) : (
                                            ""
                                        )}
                                    </tbody>
                                </table>
                                <br />
                                <button
                                    type="submit"
                                    className="blue-btn"
                                    id="submit_btn"
                                    disabled={isLoading}
                                    onClick={() => setMailServiceProvider('AWS')}
                                >
                                    Submit (AWS){" "}
                                    <span>
                                        <img src={rightArrow} alt="rightArrow" />
                                    </span>
                                </button>
                                <button
                                    type="submit"
                                    className="blue-btn"
                                    id="submit_btn_sendgrid"
                                    disabled={isLoading}
                                    onClick={() => setMailServiceProvider('Sendgrid')}
                                >
                                    Submit (SendGrid){" "}
                                    <span>
                                        <img src={rightArrow} alt="rightArrow" />
                                    </span>
                                </button>
                            </form>
                        </div>
                    </StyledOrderBlock>
                </div>
                <div className="col-md-12">

                    <StyledOrderBlock>
                        <h2>Order Details</h2>
                        <div className="table-block table-responsive">
                            <table>
                                <tbody>
                                    {OrderDetails?.order_id && (
                                        <tr>
                                            <td>Order ID:</td>
                                            <td>{OrderDetails?.order_id}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.order_id && (
                                        <tr>
                                        <td>Application Email Address</td>
                                        <td>{`${OrderDetails?.order_id}@officesend.com`}</td>
                                        </tr>
                                    )}
                                    {typeof OrderDetails?.contact_email_address != "undefined" && (
                                        <tr>
                                            <td>Email Address</td>
                                            <td>{OrderDetails?.contact_email_address}</td>
                                        </tr>
                                    )}

                                    {typeof OrderDetails?.processing_mode != "undefined" && (
                                        <tr>
                                            <td>Processing Mode</td>
                                            <td>{OrderDetails?.processing_mode == "Regular Processing" ? "Standard Processing" : OrderDetails?.processing_mode}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.signature_name && (
                                        <tr>
                                            <td>Signature Name</td>
                                            <td>{OrderDetails?.signature_name}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </StyledOrderBlock>

                    <StyledOrderBlock>
                        <h2>Visa Type Information</h2>
                        <div className="table-block table-responsive">
                            <table>
                                <tbody>
                                    {OrderDetails?.passport_from && (
                                        <tr>
                                            <td>I am travelling on a passport from</td>
                                            <td>{OrderDetails?.passport_from}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.main_purpose_of_visit && (
                                        <tr>
                                            <td>The main purpose of my visit to Indonesia is</td>
                                            <td>{OrderDetails?.main_purpose_of_visit}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.sub_purpose_of_visit && (
                                        <tr>
                                            <td>The sub purpose of my visit to Indonesia is</td>
                                            <td>{OrderDetails?.sub_purpose_of_visit}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.visa_type && (
                                        <tr>
                                            <td>I want to explore & choose a visa</td>
                                            <td>{OrderDetails?.visa_type}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.stay_day && (
                                        <tr>
                                            <td>I am planning to stay</td>
                                            <td>{OrderDetails?.stay_day}</td>
                                        </tr>
                                    )}

                                </tbody>
                            </table>
                        </div>
                    </StyledOrderBlock>

                    <StyledOrderBlock>
                        <h2>Applicant And Passport Image</h2>
                        <div className="table-block table-responsive">
                            <table>
                                <tbody>

                                    {OrderDetails?.passport_picture && (
                                        <tr>
                                            <td>Travel Document</td>
                                            <td>
                                                <a
                                                    href={`https://indonesia-evoa.online/uploads/customer/${OrderDetails?.passport_picture}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Click here
                                                </a>
                                            </td>
                                        </tr>
                                    )}
                                    {OrderDetails?.upload_picture && (
                                        <tr>
                                            <td>Photo</td>
                                            <td>
                                                <a
                                                    href={`https://indonesia-evoa.online/uploads/customer/${OrderDetails?.upload_picture}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Click here
                                                </a>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </StyledOrderBlock>

                    <StyledOrderBlock>
                        <h2>Personal and Contact Information</h2>
                        <div className="table-block table-responsive">
                            <table>
                                <tbody>

                                    {OrderDetails?.full_name && (
                                        <tr>
                                            <td>Full name</td>
                                            {/* <td>{OrderDetails?.full_name}</td> */}
                                            <td>{convertToTitleCase(OrderDetails?.full_name)}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.sex && (
                                        <tr>
                                            <td>Sex</td>
                                            <td>{OrderDetails?.sex}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.place_of_birth && (
                                        <tr>
                                            <td>Place of birth</td>
                                            <td>{OrderDetails?.place_of_birth}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.date_of_birth && (
                                        <tr>
                                            <td>
                                                Date of birth (MM/DD/YYYY)</td>
                                            <td>{OrderDetails?.date_of_birth ? moment(OrderDetails?.date_of_birth).utc().format('MM/DD/YYYY') : ""}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.contact_email_address && (
                                        <tr>
                                            <td>Email</td>
                                            <td>{OrderDetails?.contact_email_address}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.phone_number && OrderDetails?.country_code && (
                                        <tr>
                                            <td>Phone Number</td>
                                            <td>{`+${OrderDetails?.country_code} ${OrderDetails?.phone_number}`}</td>
                                        </tr>
                                    )}

                                </tbody>
                            </table>
                        </div>
                    </StyledOrderBlock>

                    <StyledOrderBlock>
                        <h2>Document Information</h2>
                        <div className="table-block table-responsive">
                            <table>
                                <tbody>
                                    {OrderDetails?.document_type && (
                                        <tr>
                                            <td>Document Type</td>
                                            <td>{OrderDetails?.document_type}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.document_number && (
                                        <tr>
                                            <td>Document No</td>
                                            <td>{OrderDetails?.document_number}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.nationality && (
                                        <tr>
                                            <td>Nationalities</td>
                                            <td>{OrderDetails?.nationality}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.date_of_expiry && (
                                        <tr>
                                            <td>
                                                Date of expiry (MM/DD/YYYY)</td>
                                            <td>{OrderDetails?.date_of_expiry ? moment(OrderDetails?.date_of_expiry).utc().format('MM/DD/YYYY') : ""}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.issuing_place && (
                                        <tr>
                                            <td>Issuing Place</td>
                                            <td>{OrderDetails?.issuing_place}</td>
                                        </tr>
                                    )}

                                </tbody>
                            </table>
                        </div>
                    </StyledOrderBlock>

                    <StyledOrderBlock>
                        <h2>Address in Indonesia</h2>
                        <div className="table-block table-responsive">
                            <table>
                                <tbody>
                                    {OrderDetails?.residence_type && (
                                        <tr>
                                            <td>Residence Type</td>
                                            <td>{OrderDetails?.residence_type}</td>
                                        </tr>
                                    )}


                                    {OrderDetails?.address && (
                                        <tr>
                                            <td>Address</td>
                                            <td>{OrderDetails?.address}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.postal_code && (
                                        <tr>
                                            <td>Postal Code</td>
                                            <td>{OrderDetails?.postal_code}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.province && (
                                        <tr>
                                            <td>Province</td>
                                            <td>{OrderDetails?.province}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.city && (
                                        <tr>
                                            <td>City</td>
                                            <td>{OrderDetails?.city}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.district && (
                                        <tr>
                                            <td>District</td>
                                            <td>{OrderDetails?.district}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.village && (
                                        <tr>
                                            <td>Village</td>
                                            <td>{OrderDetails?.village}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.immigration_office && (
                                        <tr>
                                            <td>Immigration Office</td>
                                            <td>{OrderDetails?.immigration_office}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </StyledOrderBlock>
                    <StyledOrderBlock>
                    <h2>Main document</h2>
                    <div className="table-block table-responsive">
                        <table>
                            <tbody>
                                {OrderDetails?.main_purpose_of_visit && (() => {
                                    const { main_purpose_of_visit, sub_purpose_of_visit, visa_type } = OrderDetails;
                                    const labelOptions = mainDocumentArr[main_purpose_of_visit][sub_purpose_of_visit][visa_type];
                                    const rows = [];

                                    Object.entries(labelOptions).forEach(([key, value]) => {
                                        
                                        const formattedKey = formatKey(key);

                                        if (OrderDetails[formattedKey]) {
                                            rows.push(
                                                <tr key={formattedKey}>
                                                    <td>{key}</td>
                                                    <td>
                                                        <a
                                                            href={`https://indonesia-evoa.online/uploads/customer/${OrderDetails[formattedKey]}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Click here
                                                        </a>
                                                    </td>
                                                </tr>
                                            );
                                        }

                                        if (typeof value=='object' && key == 'Support Document') {
                                            Object.entries(value).forEach(([subKey]) => {
                                                const formattedSubKey = formatKey(subKey);

                                                if (OrderDetails[formattedSubKey]) {
                                                    rows.push(
                                                        <tr key={formattedSubKey}>
                                                            <td>{subKey}</td>
                                                            <td>
                                                                <a
                                                                    href={`https://indonesia-evoa.online/uploads/customer/${OrderDetails[formattedSubKey]}`}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                >
                                                                    Click here
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            });
                                        }
                                    });

                                    return rows;
                                })()}
                            </tbody>
                        </table>
                    </div>
                </StyledOrderBlock>


                    <StyledOrderBlock>
                        <h2>Download History</h2>
                        <div className="table-block table-responsive">
                            <table width="100%">
                                <thead>
                                    <tr>
                                        <th width="5%">#</th>
                                        <th width="10%">Order ID</th>
                                        <th width="22%">Date & Time</th>
                                        <th width="23%">Downloaded File</th>
                                        <th width="20%">IP Address</th>
                                        <th width="20%">Location</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {OrderDetails?.downloadHistory ? (
                                        OrderDetails?.downloadHistory?.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item?.order_id}</td>
                                                    <td>
                                                        {moment(item?.create_ts).utc().format(
                                                            "MM/DD/YYYY hh:mm:ss"
                                                        )}{" "}
                                                        EST
                                                    </td>
                                                    <td>
                                                        {OrderDetails?.uploadDoc?.length !== 0 && (
                                                            <a
                                                                href={
                                                                    OrderDetails?.uploadDoc !== undefined
                                                                        ? `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_PUBLIC_UPLOAD_PATH}docs/${OrderDetails?.order_id}_${OrderDetails?.uploadDoc[0]?.file1}`
                                                                        : null
                                                                }
                                                                className="blue-btn"
                                                                target="_blank"
                                                                // download
                                                                rel="noreferrer"
                                                            >
                                                                Download File
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td>{item?.ip}</td>
                                                    <td>{item?.timezone}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="4" align="center">
                                                No record found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <form className="form-inline">
                                <div className="form-group">
                                    <label>
                                        <input
                                            type="email"
                                            name="email"
                                            id="email"
                                            className="form-control input-class"
                                            value={emailId}
                                            onChange={(e) => setEmailId(e.target.value)}
                                        />
                                    </label>
                                </div>
                                <div className="form-group">
                                    <button
                                        type="submit"
                                        className="blue-btn"
                                        id="download_btn"
                                        onClick={handleResendMail}
                                        disabled={isLoading}
                                    >
                                        Sent Mail{" "}
                                        <span>
                                            <img src={rightArrow} alt="rightArrow" />
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </StyledOrderBlock>
                    <AddComment />
                    <StyledOrderBlock>
                        <h2>Comment History</h2>
                        <div className="table-block table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th width="10%">#</th>
                                        <th width="20%">Order ID</th>
                                        <th width="20%">Date & Time</th>
                                        <th width="15%">Team</th>
                                        <th width="35%">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {typeof OrderDetails !== "undefined" &&
                                        OrderDetails.remark ? (
                                        OrderDetails.remark?.map((item, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td>{i + 1}</td>
                                                    <td>{item?.order_id}</td>
                                                    <td>
                                                        {moment(item?.us_date).format("MM/DD/YYYY")}
                                                        {"  "}
                                                        {item?.us_time}
                                                    </td>
                                                    <td>{item?.remark_name}</td>
                                                    <td>
                                                        {selectedData.showData &&
                                                            selectedData.dataId === item.id ? (
                                                            <div
                                                                rel="40"
                                                                className="btn blue-btn"
                                                                onClick={() =>
                                                                    setSelectedData({
                                                                        showData: !selectedData.showData,
                                                                        dataId: item?.id,
                                                                    })
                                                                }
                                                            >
                                                                {" "}
                                                                Hide
                                                            </div>
                                                        ) : (
                                                            <div
                                                                rel="40"
                                                                onClick={() =>
                                                                    setSelectedData({
                                                                        showData: !selectedData.showData,
                                                                        dataId: item?.id,
                                                                    })
                                                                }
                                                                className="btn blue-btn"
                                                            >
                                                                {" "}
                                                                Show
                                                            </div>
                                                        )}
                                                        <br />
                                                        {selectedData.showData &&
                                                            selectedData.dataId === item.id && (
                                                                <div id="40">
                                                                    <textarea
                                                                        name="remark"
                                                                        className="form-control"
                                                                        defaultValue={item?.remark}
                                                                    ></textarea>
                                                                    <b>
                                                                        Whatsapp:
                                                                        {item?.whatsapp ? item?.whatsapp : "N"}
                                                                    </b>
                                                                    <b>
                                                                        Telephone:
                                                                        {item?.telephone ? item?.telephone : "N"}
                                                                    </b>
                                                                    <b>
                                                                        Refund:
                                                                        {item?.status_refund
                                                                            ? item?.status_refund
                                                                            : "N"}
                                                                    </b>
                                                                    <b>
                                                                        Voided:
                                                                        {item?.voided ? item?.voided : "N"}
                                                                    </b>
                                                                    <b>
                                                                        Chargeback:
                                                                        {item?.chargeback ? item?.chargeback : "N"}
                                                                    </b>
                                                                    <b>
                                                                        ReportError:
                                                                        {item?.report_error
                                                                            ? item?.report_error
                                                                            : "N"}
                                                                    </b>
                                                                </div>
                                                            )}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="5" align="center">
                                                No record found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </StyledOrderBlock>
                </div>

                <StyledBottomBlock>
                    <button
                        type="button"
                        className="blue-btn"
                        data-toggle="modal"
                        data-target="#refundModal"
                        onClick={() => setShow(true)}
                    >
                        View Email Content{" "}
                    </button>

                    {/* defence pack */}
                    {(OrderDetails?.process_status == "Completed" || OrderDetails?.process_status == "Customer Called") && (
                        <>
                            <button
                                type="button"
                                className="blue-btn"
                                data-toggle="modal"
                                data-target="#defencePackModal"
                                onClick={() => setShowDefence(true)}
                            >
                                Defence Pack 1{" "}
                                <span>
                                    <img src={rightArrow} alt="rightArrow" />
                                </span>
                            </button>
                            <button
                                type="button"
                                className="blue-btn"
                                data-toggle="modal"
                                data-target="#defencePackModal1"
                                onClick={() => setShowDefencePack(true)}
                            >
                                Defence Pack 2{" "}
                                <span>
                                    <img src={rightArrow} alt="rightArrow" />
                                </span>
                            </button>

                            <button
                                type="button"
                                className="blue-btn"
                                data-toggle="modal"
                                data-target="#defencePackModal"
                                onClick={() => setShowTransaction(true)}
                            >
                                Enter Transaction Details {" "}
                            </button>
                        </>
                    )}

                    <MyModal
                        show={show}
                        close={setShow}
                        size={"lg"}
                        modalHeadTitle={"Email Content"}
                        showFooter={true}
                        primaryButtonName={"Close"}
                        secondaryButtonName={"Send Whatsapp Message"}
                        OrderDetails={OrderDetails}
                    >
                        <EmailContent />
                    </MyModal>

                    <MyModal
                        show={showDefence}
                        close={setShowDefence}
                        size={"lg"}
                        modalHeadTitle={"Defence Pack Content"}
                        showFooter={false}
                        OrderDetails={OrderDetails}
                    >
                        <DefenceContent defencePackName={null} />
                    </MyModal>
                    <MyModal
                        show={showDefencePack}
                        close={setShowDefencePack}
                        size={"lg"}
                        modalHeadTitle={"Defence Pack Content"}
                        showFooter={false}
                        OrderDetails={OrderDetails}
                    >
                        <DefenceContent defencePackName={"defencePack1"} />
                    </MyModal>

                    <MyModal
                        show={showTransaction}
                        close={setShowTransaction}
                        size={"s"}
                        modalHeadTitle={"Enter Defence Pack Details:"}
                        showFooter={false}
                        OrderDetails={OrderDetails?.length > 0 ? OrderDetails[0] : ""}
                    >
                        <TransactionModal setShowTransaction={setShowTransaction} />
                    </MyModal>

                </StyledBottomBlock>
            </div>
        </>
    );
};

export default ViewOrders;
